export default __webpack_public_path__ + "ef6a05a05fe1870ae697927ae5efddb8.svg";